import React from "react";
import { Box, Car, Check } from "lucide-react";

export function Pricing({ onContactClick }) {
  const plans = [
    {
      icon: Box,
      title: "Box Individuel",
      price: "6€",
      period: "/jour",
      features: [
        "Espace couvert et sécurisé",
        "Disponibilité 24/7",
        "Surveillance 24/7",
        "Navette gratuite",
      ],
    },
    {
      icon: Car,
      title: "Place Extérieure",
      price: "5€",
      period: "/jour",
      features: [
        "Place sécurisée",
        "Disponibilité 24/7",
        "Surveillance 24/7",
        "Navette gratuite",
      ],
      featured: true,
    },
  ];

  return (
    <section id="tarifs" className="py-20 relative overflow-hidden">
      <div className="absolute inset-0 bg-gradient-to-br from-[#FF7954]/5 to-[#FCDEBE]/10"></div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <h2 className="text-4xl font-bold text-center text-white mb-16 relative">
          Nos Tarifs
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 sm:gap-8 max-w-5xl mx-auto">
          {plans.map((plan, index) => (
            <div
              key={index}
              className={`
                p-6 sm:p-8 rounded-xl border-2 transition-all duration-300
                ${plan.featured ? "border-[#FCDEBE]" : "border-[#FF7954]"}
                hover:-translate-y-4 bg-[#0A0A0A] relative overflow-hidden h-auto sm:h-[500px] flex flex-col
              `}
            >
              <div className="absolute inset-0 bg-gradient-to-br from-[#FF7954]/5 to-[#FCDEBE]/5 opacity-0 hover:opacity-100 transition-opacity"></div>

              <div className="relative z-10 flex flex-col h-full justify-center py-4 sm:py-0">
                <div
                  className="w-16 sm:w-20 h-16 sm:h-20 bg-[#FF7954] rounded-full flex items-center justify-center mx-auto mb-4 sm:mb-6
                              transform transition-all duration-300 hover:scale-110 hover:rotate-12"
                >
                  <plan.icon size={32} className="text-white" />
                </div>

                <h3 className="text-xl sm:text-2xl font-bold text-white text-center mb-3 sm:mb-4">
                  {plan.title}
                </h3>

                <div className="text-center mb-6 sm:mb-8">
                  <span className="text-3xl sm:text-4xl font-bold text-[#FF7954]">
                    {plan.price}
                  </span>
                  <span className="text-[#FCDEBE]">{plan.period}</span>
                </div>

                <ul className="space-y-3 sm:space-y-4 mb-6 sm:mb-8">
                  {plan.features.map((feature, featureIndex) => (
                    <li
                      key={featureIndex}
                      className="flex items-center justify-center text-white text-sm sm:text-base"
                    >
                      <Check
                        size={16}
                        className="text-[#FF7954] mr-2 sm:mr-3 flex-shrink-0"
                      />
                      {feature}
                    </li>
                  ))}
                </ul>

                <div className="mt-auto">
                  <button
                    onClick={onContactClick}
                    className="w-full py-3 sm:py-4 rounded-lg text-white font-semibold text-sm sm:text-base
                             transition-all duration-300 transform hover:scale-105
                             bg-[#FF7954] hover:bg-[#e66a45] hover:shadow-lg"
                  >
                    Réserver
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
